module.exports = __webpack_public_path__ + "static/img/banner_3.4f15abc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner_3.jpg
// module id = T3LF
// module chunks = 1